import React from "react";

const BlackBackground = () => (
  <div className="black-background absolute z-0 bg-black w-full top-[40%] h-[17rem] " />
);

export default BlackBackground;
